import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface RegionalCollectionProps {
  collection: {
    id: number;
    title: string;
    region: string;
    language: string;
    storyCount: number;
    image: string;
    alt: string;
    description: string;
  };
}

const RegionalCollection = ({ collection }: RegionalCollectionProps) => {
  return (
    <div className="bg-card rounded-xl shadow-warm overflow-hidden hover:shadow-warm-lg transition-all duration-300 group">
      <div className="relative h-40 overflow-hidden">
        <AppImage
          src={collection.image}
          alt={collection.alt}
          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent" />

        <div className="absolute bottom-3 left-3 right-3">
          <div className="flex items-center space-x-2">
            <span className="px-2 py-1 bg-primary text-primary-foreground text-xs font-medium rounded-full">
              {collection.region}
            </span>
            <span className="px-2 py-1 bg-secondary text-secondary-foreground text-xs font-medium rounded-full">
              {collection.language}
            </span>
          </div>
        </div>
      </div>

      <div className="p-4">
        <h3 className="text-lg font-heading font-bold text-text-primary mb-2">
          {collection.title}
        </h3>

        <p className="text-sm text-text-secondary mb-3 line-clamp-2">
          {collection.description}
        </p>

        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-1 text-sm text-text-secondary">
            <Icon name="BookOpenIcon" size={16} />
            <span>{collection.storyCount} stories</span>
          </div>

          <button className="flex items-center space-x-1 text-primary font-medium text-sm hover:text-primary-dark transition-colors duration-200">
            <span>Explore</span>
            <Icon name="ArrowRightIcon" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegionalCollection;